<auth-splash-page>
  @if (colorMode.currentMode() === 'dark') {
    <img
      src="/assets/img/compass-logo-dark.png"
      class="align-self-center"
      alt="Compass logo"
      width="245"
      height="245"
    />
    <img src="/assets/img/brand-text-dark.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  } @else {
    <img src="/assets/img/compass-logo.png" class="align-self-center" alt="Compass logo" width="245" height="245" />
    <img src="/assets/img/brand-text.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  }
  <h1 class="mat-headline-small text-center">Forgot Password?</h1>
  <form #forgotPasswordForm="ngForm" class="d-flex flex-column" (ngSubmit)="submitReset()">
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Email address</mat-label>
      <input matInput type="email" [(ngModel)]="emailAddress" name="email" autocomplete="email" required />
    </mat-form-field>
    <button matButton="filled" type="submit" [disabled]="forgotPasswordForm.invalid">Confirm</button>
    <button matButton="text" type="button" class="mt-2" (click)="navigateBack()">Cancel</button>
  </form>
</auth-splash-page>
